// Polyfill for Razorpay and other libs that expect Node.js 'process' in browser
if (typeof window !== 'undefined' && !window.process) {
  window.process = { env: { NODE_ENV: 'production' } };
}

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const serverApi = isLocal
  ? 'http://localhost:8081/api'
  : 'https://api.abrsvs.org/api';

export const baseUrl    = serverApi;
export const socketUrl  = isLocal ? 'http://localhost:8081' : 'https://api.abrsvs.org';
export const secretKey  = process.env.REACT_APP_SECRET_KEY || 'ABRSVS-Portal-Encryption-Key-2025-SecureString';
// key_id is public — safe in code. key_secret stays on server only (never here).
export const rozerpay_key_id = isLocal
  ? 'rzp_live_TcbGWWBqC626ox'   // live key
  : 'rzp_live_TcbGWWBqC626ox';  // live key for production